import { Injectable } from '@angular/core';
import { ModalPromptModel } from '@shared/interfaces/modal-prompt-model.interface';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'platform',
})
export class ModalPromptService {
  // Controls the open/close state of the modal
  private readonly openModalSubject = new BehaviorSubject<boolean>(false);
  $openModal = this.openModalSubject.asObservable();

  // Define the modal structure
  private readonly modalStructureSubject =
    new BehaviorSubject<ModalPromptModel | null>(null);
  $modalStructure = this.modalStructureSubject.asObservable();

  // Define events for buttons
  private readonly primaryButtonClickSubject = new Subject<Event>();
  $primaryButtonClick = this.primaryButtonClickSubject.asObservable();

  private readonly warningButtonClickSubject = new Subject<Event>();
  $warningButtonClick = this.warningButtonClickSubject.asObservable();

  /**
   * Open the modal with the provided structure.
   * @param structure Modal (ModalPromptModel) Configuration
   */
  openModal(structure: ModalPromptModel): void {
    this.modalStructureSubject.next(structure);
    this.openModalSubject.next(true);
  }

  /**
   * Close the modal.
   */
  closeModal(): void {
    this.openModalSubject.next(false);
  }

  /**
   * Triggers the primary button event.
   * @param event Click event
   */
  emitPrimaryButtonClick(event: Event): void {
    this.primaryButtonClickSubject.next(event);
  }

  /**
   * Triggers the warning button event.
   * @param event Click event
   */
  emitWarningButtonClick(event: Event): void {
    this.warningButtonClickSubject.next(event);
  }
}
